import { ApolloQueryResult } from 'apollo-client';

import { topRegionQuery } from '../../graphql/queries/grid/domain';
import { TopRegionQuery } from '../../typings/graphql-grid';
import { BaseDataProvider } from '../BaseDataProvider/BaseDataProvider';

export class RegionsDataProvider extends BaseDataProvider {
    public getTopRegions = (login: string, countRegions: number): Promise<ApolloQueryResult<TopRegionQuery>> => {
        return this.createQuery<TopRegionQuery>(topRegionQuery, {
            variables: {
                input: {
                    limitOffset: {
                        limit: countRegions,
                        offset: 0
                    },
                    searchRequest: {
                        login
                    }
                }
            }
        });
    };
}
